import { lruMemoize } from 'reselect';

import type { SearchItemEntity } from '@iconik-io/shared-lib/src/redux/entities/normalized/search_item';
import { getFormatOrFileExtension } from '@iconik-io/shared-lib/src/utils/format';
import { isMediaType } from '@iconik-io/shared-lib/src/utils/media_icon_type';
import {
  MEDIA_TYPE_FILE,
  type MediaType,
} from '@iconik-io/shared-lib/src/utils/media_type';
import type { IconName } from '@iconik-io/uad';

import { getSearchItemMediaType } from './media_type';

export type ObjectIconInfo =
  | {
      type: MediaType;
    }
  | { format: string }
  | { name: IconName };

export const parseObjectIconInfo = lruMemoize(
  (searchItem: SearchItemEntity): ObjectIconInfo => {
    const mediaType = getSearchItemMediaType(searchItem);
    if (mediaType && mediaType !== MEDIA_TYPE_FILE) {
      return {
        type: mediaType,
      };
    }

    const itemFormat = getFormatOrFileExtension(searchItem);

    if (itemFormat) {
      return {
        format: itemFormat,
      };
    }

    return { type: 'file' };
  },
);

export const objectIconTypeFromMimeType = (mimeType: string): MediaType => {
  const mediaType = mimeType.split('/')[0];
  if (isMediaType(mediaType)) {
    return mediaType;
  }
  return 'file';
};
